exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "button[data-v-4e49e224]{background:transparent;border:1px solid #ddd;color:#2c3e50;padding:.5rem;padding-top:.125rem;font-size:.75rem;cursor:pointer;transition:all .5s}.action-icon[data-v-4e49e224]{transition:all .5s}button[data-v-4e49e224]:focus{outline:none}button:focus .action-icon[data-v-4e49e224],button:hover .action-icon[data-v-4e49e224]{color:#fff}button[data-v-4e49e224]:focus,button[data-v-4e49e224]:hover{background:#3498db;color:#fff}.material-icons.action-icon[data-v-4e49e224]{color:#2c3e50;font-size:1rem;position:relative;top:.25rem}.material-icons.action-icon[data-v-4e49e224]:hover{color:inherit}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4e49e224&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/NewCategory.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-4e49e224&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/NewCategory.vue
// module chunks = 0